<template>
  <div class="tw-w-full tw-min-h-screen" :style="`--primary-500: ${primaryValue}`">
    <div class="tw-flex tw-flex-col tw-bg-white tw-shadow tw-border-t tw-border-gray-200 tw-w-full tw-pt-3 tw-px-3 tw-pb-0 md:tw-justify-center">
      <div class="tw-flex tw-items-center tw-mb-2">
        <avatar class="tw-my-auto tw-mr-2" :height="70" :width="70" :businessId="businessId" :avatarType="'business'" :editable="false" />
        <div class="tw-flex tw-flex-col tw-w-full tw-ml-4">
          <div class="tw-text-xl tw-leading-tight tw-text-gray-700 tw-mb-0 tw-font-thin">{{ businessName }}</div>
          <div class="tw-text-gray-700 tw-font-light">Choose a plan</div>
        </div>
      </div>
      <div>
        <base-tabs class="tw-pb-4 md:tw-pb-0 tw-mb-0 tw-w-full" no-border @click="setFilter($event)" v-if="planGroups.length > 1">
          <base-tab v-for="group in planGroups" :key="group" :selected="group === selectedGroup" :title="group" />
        </base-tabs>
      </div>
    </div>
    <div class="tw-flex tw-flex-col tw-justify-center">
      <base-content v-show="isLoading === false">
        <div class="tw-grid tw-grid-cols-1 tw-gap-4" :class="{ 'lg:tw-grid-cols-2': filteredPlans.length > 1 }">
          <div v-for="businessPlan in filteredPlans" :key="businessPlan.id">
            <plan
              :businessId="businessId"
              :primaryColor="primaryColor"
              :secondaryColor="secondaryColor"
              :businessPlan="businessPlan"
              :businessName="businessName"
              :showButton="true"
              @selectPlanEvent="selectPlan"
              :is-selected="!!selectedBusinessPlans.find((bp) => bp.businessPlanId === businessPlan.businessPlanId)"
            />
          </div>
        </div>
      </base-content>
      <base-content v-show="isLoading === true">
        <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-4">
          <base-card v-for="i in 2" :key="i" class="tw-h-full tw-shadow-sm">
            <div class="tw-flex">
              <base-skeleton-loader class="tw-h-36 tw-w-36 tw-my-auto" />
              <div class="tw-flex tw-flex-col tw-ml-3">
                <base-skeleton-loader class="tw-h-8 tw-w-36 tw-my-2" />
                <base-skeleton-loader class="tw-h-3 tw-w-96 tw-my-1" />
                <base-skeleton-loader class="tw-h-3 tw-w-96 tw-my-1" />
                <base-skeleton-loader class="tw-h-3 tw-w-24 tw-mt-1 tw-mb-2" />
                <base-skeleton-loader class="tw-h-6 tw-w-24 tw-my-1" />
                <base-skeleton-loader class="tw-h-4 tw-w-24 tw-my-1" />
              </div>
            </div>
            <div class="tw-flex tw-flex-col tw-w-full tw-border-t tw-mt-5">
              <base-skeleton-loader class="tw-h-4 tw-w-56 tw-my-2" />
              <base-skeleton-loader class="tw-h-4 tw-w-56 tw-my-2" />
              <base-skeleton-loader class="tw-h-4 tw-w-56 tw-my-2" />
            </div>
          </base-card>
        </div>
      </base-content>
      <base-content class="tw-justify-center tw-mb-6 tw-pt-0">
        <base-button type="primary" v-if="selectedBusinessPlans.length === 0" :style="`--primary-500: ${secondaryValue}; --primary-600: ${secondaryValue};`" disabled
          >Sign Up</base-button
        >
        <base-button type="primary" v-else :style="`--primary-500: ${secondaryValue}; --primary-600: ${secondaryValue};`" @click="signup()">
          Sign Up for {{ selectedBusinessPlans.length }} plan{{ selectedBusinessPlans.length > 1 ? "s" : "" }}
        </base-button>
      </base-content>
    </div>
  </div>
</template>

<script>
import Avatar from "@/components/Avatar.vue";
import uniq from "lodash/uniq";
import Plan from "@/views/business/business-member-signup/components/Plan.vue";

export default {
  name: "MemberLocationPlans",
  components: {
    Avatar,
    Plan,
  },
  props: {
    isLoading: { type: Boolean, default: false },
    businessId: String,
    primaryColor: String,
    secondaryColor: String,
    operatingModel: String,
    businessPlans: Array,
    businessName: String,
    location: Object,
  },
  data() {
    return {
      filteredPlans: [],
      selectedBusinessPlans: [],
      selectedGroup: null,
    };
  },
  computed: {
    planGroups() {
      return this.businessPlans ? uniq(this.businessPlans.map(({ planGroup }) => planGroup)).sort() : [];
    },
    primaryValue() {
      return this.primaryColor ? this.primaryColor : "#ff0090";
    },
    secondaryValue() {
      return this.secondaryColor ? this.secondaryColor : "#404040";
    },
    locale() {
      return window.navigator.language;
    },
  },
  watch: {
    businessPlans: function() {
      this.setFilter(this.planGroups[0]);
      this.$forceUpdate();
    },
  },
  mounted() {},
  methods: {
    setFilter(group) {
      if (group) {
        this.filteredPlans = this.businessPlans.filter((plan) => plan.planGroup === group).sort((a, b) => a.sortOrder - b.sortOrder);
        this.selectedGroup = group;
        this.$emit("filterPlans", group);
      } else {
        this.filteredPlans = [...this.businessPlans].sort((a, b) => a.sortOrder - b.sortOrder);
      }
    },
    selectPlan(selectedPlanId, newValue) {
      if (newValue === false) {
        var index = this.selectedBusinessPlans.findIndex((x) => x.businessPlanId === selectedPlanId);
        this.selectedBusinessPlans.splice(index, 1);
      }
      if (newValue === true) {
        this.selectedBusinessPlans.push(this.businessPlans.find((plan) => plan.businessPlanId === selectedPlanId));
      }
    },
    signup() {
      this.$emit("signupSelection", this.selectedBusinessPlans);
    },
  },
};
</script>
